<template>
  <div class="content content-boxed">
    
    <div class="row">
      <div class="col-xs-12">

        <div class="col-xs-12">
                <h1 class="font-w300 push"><i class="fa fa-users fa-1x push-5-r "></i>{{actualGroup.group_name}}</h1>
        </div>
        <div  class="col-xs-12">

            <div class="col-xs-6">
                <div v-if="actualGroupLevel===1" class="presets-container form-group row text-center">
                   <button type="button" @click="displayAddGroupToUser=1" class="btn btn-success btn-rounded" name="button"><i class="fa fa-plus fa-1x push-5-r "></i>Ajouter un groupe de Niveau 1</button>
                </div>
            </div>

            <div class="col-xs-6">
                <div class="presets-container form-group row text-center">
                   <button type="button" @click="loadLiveMonitor()" class="btn btn-success btn-rounded" name="button"><i class="fa fa-handshake-o fa-1x push-5-r "></i>Accepter une invitation de partage</button>
                </div>
            </div>

        </div>


        <div v-if="displayAddGroupToUser"  class="col-xs-12">
          <div class="block block-rounded">
            <div class="block-content">
              <create-group-form  componentState = "01"></create-group-form>
              <div class="presets-container form-group row text-center">
              <button type="button" @click="closeDisplayAddGroupToUser()" class="btn btn-success btn-rounded" name="button"><i class="fa fa-close fa-1x push-5-r "></i>Fermer</button> 
              </div> 
            </div>
          </div>
        </div>
                
        
        <div class="row">
        </div>



        <div class="block block-rounded" v-if="actualGroup.permissions.GrpLinkedProfileRead[0]">
          <div class="block-header">
            <h2 class="block-title"><i class="fa fa-user fa-2x push-5-r "></i>Usagers</h2>
              <table class="table table-striped remove-margin-b font-s16">
                <thead>
                  <tr>
                    <th>Usager</th>
                    <th>Type d'accès</th>
                    <th>Accès</th>

                  </tr>
                </thead>
                <tbody>
                  <tr v-for="profile in actualGroup.linked_profile">
                    <td class="font-w600 text-muted">{{profile.email}}</td>
                    <td class="hidden-xs">
                        <span v-if="profile.rule.rule_id==='Full Access'" class="label label-success">Plein Accèes</span>
                        <span v-else class="label label-primary">Personalisé</span>
                    </td>

                    <td class="text-left">
                        <div class="btn-group">
                            <button v-if="profile.rule.rule_id==='Full Access'" class="btn btn-default" type="button" data-toggle="tooltip" title="Créer un accèes personalisé"><i class="fa fa-plus-square"></i></button>
                            <button v-else class="btn btn-default" type="button" data-toggle="tooltip" title="Modifier les accèes"><i class="fa fa-pencil"></i></button>
                            <button class="btn btn-default" type="button" data-toggle="tooltip" title="Retirer l'usager"><i class="fa fa-times"></i></button>
                        </div>
                    </td>
                  </tr>
                </tbody>
              </table>

                <div class="presets-container form-group row text-center" v-if="actualGroup.permissions.GrpSharingEnable[0]">
                    <button type="button" @click="loadLiveMonitor()" class="btn btn-success btn-rounded" name="button"><i class="fa fa-share-alt fa-1x push-5-r "></i>Inviter un usager au groupe</button>
                </div>
          </div>
        </div>



        <div class="block block-rounded" v-if="actualGroup.permissions.GrpSubGroupRead[0]">
          <div class="block-header">
            <h2 class="block-title"><i class="fa fa-users fa-2x push-5-r "></i>Sous groupes d'usagers</h2>
              <table class="table table-striped remove-margin-b font-s14">
                <thead>
                  <tr>
                    <th>Groupes</th>
                    <th>#Sous Groupes</th>
                    <th>#Groupes Système</th>

                  </tr>
                </thead>
                <tbody>
                  <tr v-for="group in actualGroup.sub_group">
                    <td class="font-w600 text-muted">{{group.group_name}}</td>
                    <td class="font-w600 text-muted">{{group.sub_group.length}}</td>
                    <td class="font-w600 text-muted">{{group.bundles.length}}</td>
                  </tr>
                </tbody>
              </table>

              <div class="presets-container form-group row text-center" v-if="actualGroup.permissions.GrpSubGroupWrite[0]">
                  <button type="button" @click="displayAddSubGroupToGroup=1" class="btn btn-success btn-rounded" name="button"><i class="fa fa-plus fa-1x push-5-r "></i>Ajouter un sous-groupe usagers</button>
              </div>

              <div v-if="displayAddSubGroupToGroup"  class="col-xs-12">
                <div class="block block-rounded">
                  <div class="block-content">
                    <create-sub-group-form  componentState = "01"></create-sub-group-form>
                    <div class="presets-container form-group row text-center">
                    <button type="button" @click="closeDisplayAddSubGroupToGroup()" class="btn btn-success btn-rounded" name="button"><i class="fa fa-close fa-1x push-5-r "></i>Fermer</button> 
                    </div> 
                  </div>
                </div>
              </div>

          </div>
        </div>


        <div class="block block-rounded" v-if="actualGroup.permissions.GrpBundleRead[0]">
          <div class="block-header">
            <h2 class="block-title"><i class="fa fa-database fa-2x push-5-r "></i>Groupes système</h2>
              <table class="table table-striped remove-margin-b font-s14">
                <thead>
                  <tr>
                    <th>Groupes système</th>
                    <th>Type</th>
                    <th>#Device</th>
                    <th>#Canaux</th>

                  </tr>
                </thead>
                <tbody>
                  <tr v-for="bundle in actualGroup.bundles">
                    <td class="font-w600 text-muted">{{bundle.bundle_name}}</td>
                    <td class="font-w600 text-muted">{{bundle.bundle_type}}</td>
                    <td class="font-w600 text-muted">{{bundle.devices.length}}</td>
                    <td class="font-w600 text-muted">{{bundle.channels.length}}</td>
                  </tr>
                </tbody>
              </table>

                <div class="presets-container form-group row text-center" v-if="actualGroup.permissions.GrpSubGroupWrite[0]">
                    <button type="button" @click="loadLiveMonitor()" class="btn btn-success btn-rounded" name="button"><i class="fa fa-plus fa-1x push-5-r "></i>Ajouter un groupe système</button>
                </div>
          </div>
        </div>

      </div>

      <div class="col-xs-12 col-sm-12">
        <div class="block block-rounded">
          <div class="block-content">

          </div>
        </div>
      </div>



    </div>
  </div>
</template>

<script>

import Spinner from '@/components/Spinner'

import {mapState, mapActions, mapGetters} from 'vuex'
import CreateGroupForm from '@/views/group/CreateGroupForm'
import CreateSubGroupForm from '@/views/group/CreateSubGroupForm'

export default {
  name: 'groupIndex',
  data() {
    return {
      displayAddGroupToUser : false,
      displayAddSubGroupToGroup : false,
      selectedDevices: 0,
      loadingPort: true,
      localIp : '',
      actualLanguage : "FR",
      labelTopPage: {FR: 'Mesure électrique', EN: 'Energy monitor'},
    }
  },
  components: {
    Spinner,
    CreateGroupForm,
    CreateSubGroupForm
  },
  computed: {
    ...mapState('sessionStore', ['userEmail','profileData','groupArborescence','actualGroup','actualBundle']),
    ...mapState('groupStore', ['actualGroupLevel'])
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

    closeDisplayAddGroupToUser(){
        this.displayAddGroupToUser=false
        this.$store.dispatch('sessionStore/getGroupArborescence')  
    },

    closeDisplayAddSubGroupToGroup(){
        this.displayAddSubGroupToGroup=false
        this.$store.dispatch('sessionStore/getGroupArborescence')  
    },

    },

  mounted() {
    //this.getDeviceData()
    //console.log("Measurement_Index_Mounted");
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  }
}
</script>





// WEBPACK FOOTER //
// Index.vue?48e9d812